// src/actions/dashboardadmin_actions.js

import axios from 'axios';
import {
  FETCH_ADMIN_USER_STATS_LOADING,
  FETCH_ADMIN_USER_STATS_SUCCESS,
  FETCH_ADMIN_USER_STATS_FAIL,
  FETCH_ADMIN_RECIPES_STATS_LOADING,
  FETCH_ADMIN_RECIPES_STATS_SUCCESS,
  FETCH_ADMIN_RECIPES_STATS_FAIL,
  FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING,
  FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS,
  FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL,
  FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING,
  FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS,
  FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL,
  FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING,
  FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS,
  FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL,
  FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING,
  FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS,
  FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL,
  FETCH_ADMIN_BRANDS_STATS_LOADING,
  FETCH_ADMIN_BRANDS_STATS_SUCCESS,
  FETCH_ADMIN_BRANDS_STATS_FAIL,
  FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING,
  FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS,
  FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL,
  FETCH_ADMIN_BARS_STATS_LOADING,
  FETCH_ADMIN_BARS_STATS_SUCCESS,
  FETCH_ADMIN_BARS_STATS_FAIL,
  FETCH_ADMIN_BLOG_STATS_LOADING,
  FETCH_ADMIN_BLOG_STATS_SUCCESS,
  FETCH_ADMIN_BLOG_STATS_FAIL,
  FETCH_ADMIN_BLOG_NEWS_STATS_LOADING,
  FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS,
  FETCH_ADMIN_BLOG_NEWS_STATS_FAIL,
  FETCH_ADMIN_USER_ADDITIONAL_LOADING,
  FETCH_ADMIN_USER_ADDITIONAL_SUCCESS,
  FETCH_ADMIN_USER_ADDITIONAL_FAIL,
  FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING,
  FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS,
  FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL,
  FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING,
  FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS,
  FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL,
  FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING,
  FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS,
  FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL,
  FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST,
  FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS,
  FETCH_LIKE_RECIPE_ADDITIONAL_FAIL,
  FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST,
  FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS,
  FETCH_VIEW_RECIPE_ADDITIONAL_FAIL,
  FETCH_ADMIN_BRAND_ADDITIONAL_LOADING,
  FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS,
  FETCH_ADMIN_BRAND_ADDITIONAL_FAIL,
  FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING,
  FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS,
  FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL,
  FETCH_ADMIN_BLOG_ADDITIONAL_LOADING,
  FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS,
  FETCH_ADMIN_BLOG_ADDITIONAL_FAIL,
  FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING,
  FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS,
  FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL
} from './types';

const BASE = process.env.REACT_APP_ADMIN_API_ADDRESS;
// 🔁 Switched to the merged stats endpoint (defaults to MySQL)
const API_DATA        = `${BASE}/secureapi/analytics/admindata/admin-data-api-merged`;
const API_ADDL_MERGED = `${BASE}/secureapi/analytics/admindata/admin-additional-api-merged`;

/* --------------------------- ADDITIONAL (DETAILS) --------------------------- */

export const fetchAdminBlogStatisticsAdditionalData =
  (startTime, endTime) => async dispatch => {
    dispatch({ type: FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_LOADING });
    try {
      const token = localStorage.getItem('jwtToken');
      const resp = await axios.get(API_ADDL_MERGED, {
        headers: { Authorization: `Bearer ${token}` },
        params:  { table: 'blog_statistics', startTime, endTime }
      });
      if (resp.data.success) {
        dispatch({ type: FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch blog statistics details' });
      }
    } catch (err) {
      dispatch({ type: FETCH_ADMIN_BLOG_STATISTICS_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
    }
  };

export const fetchAdminBlogAdditionalData = (startTime, endTime) => async dispatch => {
  dispatch({ type: FETCH_ADMIN_BLOG_ADDITIONAL_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { table: 'blog', startTime, endTime }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BLOG_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BLOG_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch blog details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BLOG_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBrandCategoryAdditionalData = (startTime, endTime) => async dispatch => {
  dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { table: 'brand_category', startTime, endTime }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch brand‐category details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBrandAdditionalData = (startTime, endTime) => async dispatch => {
  dispatch({ type: FETCH_ADMIN_BRAND_ADDITIONAL_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { table: 'brand', startTime, endTime }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BRAND_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BRAND_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch brand details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BRAND_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminViewRecipeAdditionalData = (startTime, endTime) => async dispatch => {
  dispatch({ type: FETCH_VIEW_RECIPE_ADDITIONAL_REQUEST });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { table: 'click_recipe', startTime, endTime }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_VIEW_RECIPE_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_VIEW_RECIPE_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch view recipe details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_VIEW_RECIPE_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminLikeRecipeAdditionalData = (startTime, endTime) => async dispatch => {
  dispatch({ type: FETCH_LIKE_RECIPE_ADDITIONAL_REQUEST });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { table: 'like_recipe', startTime, endTime }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_LIKE_RECIPE_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_LIKE_RECIPE_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch like recipe details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_LIKE_RECIPE_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminMakeRecipeAdditionalData =
  (startTime, endTime) => async (dispatch) => {
    dispatch({ type: FETCH_ADMIN_MAKE_RECIPE_ADDL_LOADING });
    try {
      const token = localStorage.getItem('jwtToken');
      const resp = await axios.get(API_ADDL_MERGED, {
        headers: { Authorization: `Bearer ${token}` },
        params:  { table: 'make_recipe', startTime, endTime }
      });
      if (resp.data.success) {
        dispatch({ type: FETCH_ADMIN_MAKE_RECIPE_ADDL_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL, payload: resp.data.message || 'Failed to fetch make-recipe details' });
      }
    } catch (err) {
      dispatch({ type: FETCH_ADMIN_MAKE_RECIPE_ADDL_FAIL, payload: err.response?.data?.message || err.message });
    }
  };

export const fetchAdminCustomRecipesAdditionalData =
  (startTime, endTime) => async (dispatch) => {
    dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_ADDL_LOADING });
    try {
      const token = localStorage.getItem('jwtToken');
      const resp = await axios.get(API_ADDL_MERGED, {
        headers: { Authorization: `Bearer ${token}` },
        params:  { table: 'custom_recipe', startTime, endTime }
      });
      if (resp.data.success) {
        dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_ADDL_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL, payload: resp.data.message || 'Failed to fetch custom recipes details' });
      }
    } catch (err) {
      dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_ADDL_FAIL, payload: err.response?.data?.message || err.message });
    }
  };

export const fetchAdminCuratedRecipesAdditionalData =
  (startTime, endTime) => async (dispatch) => {
    dispatch({ type: FETCH_ADMIN_CURATED_RECIPES_ADDL_LOADING });
    try {
      const token = localStorage.getItem('jwtToken');
      const resp = await axios.get(API_ADDL_MERGED, {
        headers: { Authorization: `Bearer ${token}` },
        params:  { startTime, endTime, table: 'recipe' }
      });
      if (resp.data.success) {
        dispatch({ type: FETCH_ADMIN_CURATED_RECIPES_ADDL_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL, payload: resp.data.message || 'Failed to fetch curated recipes details' });
      }
    } catch (err) {
      dispatch({ type: FETCH_ADMIN_CURATED_RECIPES_ADDL_FAIL, payload: err.response?.data?.message || err.message });
    }
  };

export const fetchAdminUserAdditionalData = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_USER_ADDITIONAL_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp  = await axios.get(API_ADDL_MERGED, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'user' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_USER_ADDITIONAL_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_USER_ADDITIONAL_FAIL, payload: resp.data.message || 'Failed to fetch additional user data' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_USER_ADDITIONAL_FAIL, payload: err.response?.data?.message || err.message });
  }
};

/* ------------------------------ COUNTS / STATS ------------------------------ */

export const fetchAdminBlogNewsStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_BLOG_NEWS_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'blog_statistics' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BLOG_NEWS_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BLOG_NEWS_STATS_FAIL, payload: resp.data.message || 'Failed to fetch blog/news view stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BLOG_NEWS_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBlogStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_BLOG_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'blog' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BLOG_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BLOG_STATS_FAIL, payload: resp.data.message || 'Failed to fetch blog stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BLOG_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBrandCategoryStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'brand_category' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL, payload: resp.data.message || 'Failed to fetch brand category stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BRAND_CATEGORY_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBrandsStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_BRANDS_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'brand' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BRANDS_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BRANDS_STATS_FAIL, payload: resp.data.message || 'Failed to fetch brand stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BRANDS_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminBarsStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_BARS_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'bar' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_BARS_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_BARS_STATS_FAIL, payload: resp.data.message || 'Failed to fetch bars stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_BARS_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminViewRecipesStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_VIEW_RECIPES_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'click_recipe' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_VIEW_RECIPES_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL, payload: resp.data.message || 'Failed to fetch view recipes stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_VIEW_RECIPES_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminLikeRecipesStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_LIKE_RECIPES_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'like_recipe' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_LIKE_RECIPES_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL, payload: resp.data.message || 'Failed to fetch like recipes stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_LIKE_RECIPES_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminMakeRecipesStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_MAKE_RECIPES_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp  = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'make_recipe' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_MAKE_RECIPES_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL, payload: resp.data.message || 'Failed to fetch make recipes stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_MAKE_RECIPES_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminCustomRecipesStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp  = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'custom_recipe' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL, payload: resp.data.message || 'Failed to fetch custom recipes stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_CUSTOM_RECIPES_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminRecipesStats = (startTime, endTime) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_RECIPES_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const resp  = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table: 'recipe' }
    });
    if (resp.data.success) {
      dispatch({ type: FETCH_ADMIN_RECIPES_STATS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_RECIPES_STATS_FAIL, payload: resp.data.message || 'Failed to fetch curated recipes stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_RECIPES_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};

export const fetchAdminUserStats = (startTime, endTime, table) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_USER_STATS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const response = await axios.get(API_DATA, {
      headers: { Authorization: `Bearer ${token}` },
      params:  { startTime, endTime, table }
    });
    const { data } = response;
    if (data.success) {
      dispatch({ type: FETCH_ADMIN_USER_STATS_SUCCESS, payload: data.data });
    } else {
      dispatch({ type: FETCH_ADMIN_USER_STATS_FAIL, payload: data.message || 'Failed to fetch admin stats' });
    }
  } catch (err) {
    dispatch({ type: FETCH_ADMIN_USER_STATS_FAIL, payload: err.response?.data?.message || err.message });
  }
};
